export class TfaVerifyRegisteredRequestDto {
  constructor(
    public code: string,
  ) { }
}